import React from 'react';
import { Box, Typography, Paper, Grid, Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIcon from '@mui/icons-material/Phone';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import StoreIcon from '@mui/icons-material/Store';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import moment from 'moment';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
const DetailChofer = ({ row }) => {
    const chofer = row.original;
    
    // Función para formatear fechas
    const formatDate = (date) => {
        if (!date) return "No hay registro";
        return moment(date).format("DD-MM-YYYY");
    };

    // Función para mostrar valor o "No registrado"
    const showValue = (value) => {
        return value || value === 0 ? value : "No registrado";
    };

    // Función para mostrar estado del chofer
    const getStatusChip = (activo) => {
        return activo === 1 ? (
            <Chip 
                label="Activo" 
                color="success" 
                size="small" 
                icon={<PersonIcon />}
            />
        ) : (
            <Chip 
                label="Inactivo" 
                color="error" 
                size="small" 
                icon={<PersonIcon />}
            />
        );
    };

    return (
        <Paper 
            elevation={3} 
            sx={{ 
                p: 3, 
                m: 2, 
                backgroundColor: '#f8f9fa',
                border: '1px solid #e0e0e0',
                borderRadius: 2
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <PersonIcon sx={{ fontSize: 32, mr: 1, color: '#2471A3' }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2471A3' }}>
                    Detalles del Chofer
                </Typography>
                <Box sx={{ ml: 2 }}>
                    {getStatusChip(chofer.activo)}
                </Box>
            </Box>

            <Grid container spacing={3}>
                {/* Información Personal */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Información Personal
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <BadgeIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {chofer.nombre_apellido || "No registrado"}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <BadgeIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>DNI:</strong> {chofer.dni || "No registrado"}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <BadgeIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Legajo:</strong> {showValue(chofer.legajo)}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <PhoneIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Teléfono:</strong> {chofer.telefono || "No registrado"}
                            </Typography>
                        </Box>
                        
                    </Box>
                </Grid>

                {/* Información de Sucursal y Ventas */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Información de Sucursal y Ventas
                        </Typography>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <LocalGasStationIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Caja MercadoLibre:</strong> {chofer.caja_mercadolibre || "No registrada"}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <AdUnitsIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Posnet:</strong> {chofer.posnet || "No registrada"}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <FactCheckIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                            <Typography variant="body1">
                                <strong>Negocio:</strong> {showValue(chofer.valor)}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>

                {/* Fechas de Vencimiento */}
                <Grid item xs={12}>
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Fechas de Vencimiento
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Licencia:</strong> {formatDate(chofer.vencimiento_licencia)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>ART:</strong> {formatDate(chofer.fecvto_art)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Curso CP:</strong> {formatDate(chofer.fecvto_cursocp)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Protocolo Cal:</strong> {formatDate(chofer.fecvto_protcal)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Psicofísico:</strong> {formatDate(chofer.fecvto_psicof)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Remito:</strong> {formatDate(chofer.fecvto_remito)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>SVO:</strong> {formatDate(chofer.fecvto_svo)}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, fontSize: 20, color: '#2471A3' }} />
                                    <Typography variant="body2">
                                        <strong>Examen Carga:</strong> {formatDate(chofer.examen_carga)}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

            </Grid>
        </Paper>
    );
};

export default DetailChofer;